import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { FlowProvider, useFlow } from './../../context/FlowContext';
import AndroidIntro from './AndroidIntro.jsx';
import VisorID from './VisorID';
import InstallOver14 from './InstallOver14';
import InstallUnder14 from './InstallUnder14';
import FinalChecks from './FinalChecks';
import AndroidDesktopPage from './AndroidDesktopPage'; // ⬅️ NEW

const RequireVisorCreated = ({ children }) => {
  const { created } = useFlow();
  const loc = useLocation();
  if (!created) return <Navigate to="visor-id" replace state={{ from: loc }} />;
  return <>{children}</>;
};

// Simple UA check – this is only running in the browser
const isAndroidDevice = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /Android/i.test(ua);
};

export default function InstallRouter() {
  const onAndroid = isAndroidDevice();

  // ✅ Desktop / non-Android: single white-themed page
  if (!onAndroid) {
    return (
      <FlowProvider>
        <AndroidDesktopPage />
      </FlowProvider>
    );
  }

  // ✅ Android devices: multi-step dark flow
  return (
    <FlowProvider>
      <Routes>
        <Route path="/" element={<AndroidIntro />} />
        <Route path="visor-id" element={<VisorID />} />
        <Route path="instover14" element={<InstallOver14 />} />
        <Route path="inunder14" element={<InstallUnder14 />} />
        <Route
          path="final-checks"
          element={
            <RequireVisorCreated>
              <FinalChecks />
            </RequireVisorCreated>
          }
        />
        {/* stay inside /android on unknown paths */}
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </FlowProvider>
  );
}
